import { useEffect } from "react";
import { redirectToBffLogin } from "utils/auth/bffRedirect";

/**
 * Handles the public `/bff` path by sending the browser to the BFF login
 * endpoint (which kicks off the Keycloak OIDC flow). Runs the navigation as a
 * side effect so render stays pure.
 */
export default function BffLoginRedirect(): null {
  useEffect(() => {
    redirectToBffLogin("/");
  }, []);

  return null;
}
